import { IDanhSachDuDieuKienThucTapActionTypes } from "../../action-types/xet-thuc-tap/IDanhSachDuDieuKienThucTapActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDanhSachDuDieuKienThucTapReducer } from "../../reducer-model/xet-thuc-tap/IDanhSachDuDieuKienThucTapReducer";

const iniState : IDanhSachDuDieuKienThucTapReducer = {
    status: eReducerStatusBase.is_not_initialization,
    danhSachDuDieuKienThucTaps: [],
    danhSachDuDieuKienChiTietDiem: {
        danhSachDuDieuKiens: [],
        diemXets: []
    },
}

export const danhSachDuDieuKienThucTapReducer = (state: IDanhSachDuDieuKienThucTapReducer = iniState, action: IDanhSachDuDieuKienThucTapActionTypes): IDanhSachDuDieuKienThucTapReducer => {
    switch (action.type) {
        case "DANH_SACH_DU_DIEU_KIEN_THUC_TAP_LOAD_BY_DOT_THUC_TAP_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "DANH_SACH_DU_DIEU_KIEN_THUC_TAP_LOAD_BY_DOT_THUC_TAP_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                danhSachDuDieuKienThucTaps: action.payload
            };
        case "DANH_SACH_DU_DIEU_KIEN_THUC_TAP_LOAD_BY_DOT_THUC_TAP_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "DANH_SACH_DU_DIEU_KIEN_THUC_TAP_LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "DANH_SACH_DU_DIEU_KIEN_THUC_TAP_LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                danhSachDuDieuKienChiTietDiem: action.payload,
            };
        case "DANH_SACH_DU_DIEU_KIEN_THUC_TAP_LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        default:
            return state;
    }
};